export default {
  payment_methods_title: 'Ihre Zahlungsdetails',
  monthly_payment_method_title: 'Monatliche Zahlungsmethode:',
  monthly_payment_method_not_specified_title:
    'Monatliche Zahlungsmethode hinterlegt.',
  non_deposited: 'Keine Zahlungsmethode hinterlegt',
  payment_methods_intro:
    'Hier können Sie die Zahlungsmethode für Ihre monatliche Rechnung hinterlegen. ',
}
